import React, { useState, useEffect, useRef, useContext } from "react";
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Steps } from 'primereact/steps';
import { Panel } from 'primereact/panel';
import { useHistory } from "react-router-dom";
import { AppConfig } from "../../../App.config.js";

import { Context } from "../../../AppProvider.js"

import GAS from "../../../GAS.js";

import DialogConcordanciaParticipar from '../DialogConcordanciaParticipar/index.js';
import ButtonAvancarQuestionario from "../ButtonAvancarQuestionario/index.js";
import ButtonRetrocederQuestionario from "../ButtonRetrocederQuestionario/index.js";
import RenderizarQuestionario from "../RenderizarQuestionario/index.js";
import RenderRespostaQuestaoAberta from "../RenderQuestoesAbertas/index.js";
import RenderQuestoesFechadas from "../RenderQuestoesFechadas/index.js";

import "./styles.css";

const Questionario = (props) => {

    const [etapaGrupoQuestaoSelecionado, setEtapaGrupoQuestaoSelecionado] = useState(0); //steps
    const [questionario, setQuestionario] = useState(undefined);
    const [startResponder, setStartResponder] = useState(true);
    const [etapa, setEtapa] = useState('I'); //{'I', INÍCIO}, {'Q', QUESTIONARIO}, {'F', FINAL}
    const [respostas, setRespostas] = useState({}); // respostas é um objeto que contém várias respostas, mapeadas pelo id da questão.
    const { setQuestionarios } = useContext(Context);//context atualizado para atualizar a lista de questionarios de um usuario, assim que um questionario for respondido.

    const toast = useRef(null); // utilizado para exibir mensagens temporárias na tela
    const history = useHistory(); 


    useEffect(() => {
        if (props.questionario !== questionario) {
            setQuestionario(props.questionario);
        }
    }, [props.questionario, questionario]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [etapaGrupoQuestaoSelecionado, etapa]);


    const showMessage = (type, summary, detail) => {
        toast.current.show({ severity: type, summary: summary, detail: detail, life: 8000, closable: false });
    }

    //Modifica a etapa de apresentação do questionário
    const handleSetEtapaQuestionario = (etapaIndex) => {  
        let ordemEtapas = ['I', 'Q', 'F']; //ordem de etapas do questionário, respectivamente: I-nício, Q-uestionário, F-im.

        let etapaAtual = etapa;
        etapaAtual = ordemEtapas.indexOf(etapaAtual);

        let proximaEtapa = etapaAtual + etapaIndex;
        if (proximaEtapa < 0) {
            proximaEtapa = 0;
        } else if (proximaEtapa > ordemEtapas.length - 1) {
            proximaEtapa = ordemEtapas.length - 1;
        }

        proximaEtapa = ordemEtapas[proximaEtapa];
        setEtapa(proximaEtapa);

    };

    // Modifica a etapa de apresentação do grupo de questões     
    // Avança para o próximo grupo de questões
    const handleAvancarEtapaGrupoQuestao = (etapaIndex) => {
        if (etapaIndex > 0 && !updateValidarRespostas()) {
            showMessage('error', 'ATENÇÃO!', (<div>É necessário responder as questões em <b>VERMELHO</b> antes de <i className="pi pi-arrow-right" /> <b>AVANÇAR</b>.</div>));
            window.scrollTo(0, 0);
            return;
        }

        let proximaEtapaGrupoQuestao = etapaGrupoQuestaoSelecionado + etapaIndex;
        if (proximaEtapaGrupoQuestao < 0 || proximaEtapaGrupoQuestao >= questionario.gruposQuestoes.length) {
            handleSetEtapaQuestionario(etapaIndex);
        } else {
            setEtapaGrupoQuestaoSelecionado(proximaEtapaGrupoQuestao);
        }
    };


    //Envia um objeto questionario para o serviço GAS 'MCPAQuestionario.instance.SERVICE.POSTRespostasQuestionario'.
    const handleEnviarRespostas = () => {
        const gasObj = GAS.getInstance();
        let questionarioAtual = { ...questionario };

        questionarioAtual.gruposQuestoes.forEach((grupoQuestao) => {
            grupoQuestao.questoes.forEach((questao) => {
                if (isQuestaoDimensionalizadaFechada(questao)) {
                    questao.indicadores.forEach((indicador) => {
                        indicador.resposta = respostas[indicador.id];
                    });
                } else if (isQuestaoAberta(questao)) {
                    questao.resposta = respostas[questao.id]?.trim().replace(/\r?\n|\r|\t/gi, " ") || null;
                }
            });
        });

        showMessage('warn', 'AGUARDE!', 'Por favor aguarde, em instantes o registro de sua avaliação será concluído...');
        gasObj.request('MCPAQuestionario.instance.SERVICE.POSTRespostasQuestionario', questionarioAtual, props.usuario.email)
            .then((RESPONSE) => {
                questionarioAtual.respondidoEm = RESPONSE.response.respondidoEm;                
                showMessage('success', 'SUCESSO!', 'Sua avaliação foi registrada com sucesso.');
                setEtapa('I');
                
                setTimeout(() => {
                    history.replace({ pathname: `/questionarios` });
                    setQuestionarios(RESPONSE.response.questionarioAtualizado);                  
                }, 1150);
             
            }).catch(() => {
                questionarioAtual.respondidoEm = undefined;
                showMessage('error', 'ERRO!', `Não foi possível registrar a sua avaliação. Tente novamente e se o problema persistir contate ${AppConfig.CPA_EMAIL}`);
            
            })
    };


    //Modifica o DOM de questões do questionário, aplicando-lhes a classe 'resposta-invalida' ou 'resposta-valida', a depender do tipo de questão.
    const updateValidarRespostas = () => {
        let countInvalidades = 0;

        let getIndicadorElement = (questaoId, indicadorIndex) => {
            return document.querySelector(`div[id="${questaoId}"] .p-datatable-wrapper table tbody tr:nth-child(${indicadorIndex + 1})`);
        }

        questionario.gruposQuestoes[etapaGrupoQuestaoSelecionado].questoes.forEach(questao => {
            if (questao.indicadores) {
                questao.indicadores.forEach((indicador, index) => {
                    let element = getIndicadorElement(questao.id, index);

                    if (respostas[indicador.id] === undefined) {
                        element.classList.remove('resposta-valida');
                        element.classList.add('resposta-invalida');
                        countInvalidades++;

                    }else{
                        element.classList.remove('resposta-invalida');
                        element.classList.add('resposta-valida');
                    }
                });
            }
        });
        return countInvalidades === 0;
        //varre todas as questões do tipo DIMENSIONALIZADA_FECHADA (indicador !== undefined) e para cada um analisa se há resposta.
    };

    
    // Verifica se há questionario e grupo de questoes e atribui um label
    const etapas = () => {
        return questionario.gruposQuestoes.map(grupoQuestao => ({ label: grupoQuestao.titulo })) || [];
    };

    
    const renderActions = () => (
        <span className="questionario-actions">
            <ButtonRetrocederQuestionario
                etapa={etapa}
                handleAvancarEtapaGrupoQuestao={handleAvancarEtapaGrupoQuestao}
                handleSetEtapaQuestionario={handleSetEtapaQuestionario}
            />
            <ButtonAvancarQuestionario
                etapa={etapa}
                handleAvancarEtapaGrupoQuestao={handleAvancarEtapaGrupoQuestao}
                handleSetEtapaQuestionario={handleSetEtapaQuestionario}
                handleEnviarRespostas={handleEnviarRespostas}
            />
        </span>
    );


    const renderQuestoes = (grupoQuestaoIndex) => (
        questionario.gruposQuestoes[grupoQuestaoIndex].questoes.map(questao => ( 
            <Card key={questao.id} title={<div dangerouslySetInnerHTML={{ __html: questao.titulo }} />} subTitle={<div dangerouslySetInnerHTML={{ __html: questao.descricao }} />}>
                <RenderQuestoesFechadas
                    questao={questao}
                    escalaAvaliativa={questionario.escala.escalaAvaliativa}
                    isQuestaoDimensionalizadaFechada={isQuestaoDimensionalizadaFechada}
                    state={{ ...respostas }}
                    alterarEstadoIndicadorQuestoesFechadas={(indicadorId, value) => setRespostas({ ...respostas, [indicadorId]: value })}
                    etapa={etapa}
                />
                <RenderRespostaQuestaoAberta
                    questao={questao}
                    capturarRespostaQuestaoAberta={(questaoId, value) => setRespostas({ ...respostas, [questaoId]: value })}
                    isQuestaoAberta={isQuestaoAberta}
                    state={{ ...respostas }}
                />
            </Card>
        ))
    );


    const renderPrePosEtapa = (campoQuestionarioTexto, etapaAtual) => {
        const tituloEtapa = etapaAtual === 'I' ? 'Início do Questionário' : 'Término do Questionário';
        return (
            <RenderizarQuestionario
                questionario={questionario}
                stateQuestionario={questionario}
                tituloEtapa={tituloEtapa}
                renderActions={renderActions}
                etapa={etapaAtual}
                campoQuestionarioTexto={campoQuestionarioTexto}
            />
        );
    };


    const isQuestaoDimensionalizadaFechada = (questao) => {
        return questao.tipo === 'DIMENSIONALIZADA_FECHADA' && questao.indicadores;
    }

    const isQuestaoAberta = (questao) => {
        return questao.tipo === 'ABERTA' || questao.tipo === 'DIMENSIONALIZADA_ABERTA';
    }

    console.log(questionario)
    return (
        <div>
            <Toast ref={toast} position="top-left" />
            {startResponder ? <DialogConcordanciaParticipar estado={{ startResponder }} alterarEstado={() => setStartResponder(false)} alterarEtapa={() => setEtapa('I')} /> :
                (etapa === 'I' ? renderPrePosEtapa(questionario.textoInicial, 'I') :
                    etapa === 'F' ? renderPrePosEtapa(questionario.textoFinal, 'F') :
                        <>
                            <div className="questionario-etapas">
                                <Steps model={etapas()} activeIndex={etapaGrupoQuestaoSelecionado} onSelect={(e) => setEtapaGrupoQuestaoSelecionado(e.index)} />
                                {renderActions()}
                            </div>
                            <div className="questionario-questoes">
                                <Panel>
                                    <div className="p-mb-4 p-text-center">{<div dangerouslySetInnerHTML={{ __html: questionario.gruposQuestoes[etapaGrupoQuestaoSelecionado].descricao }} />}</div>
                                    {renderQuestoes(etapaGrupoQuestaoSelecionado)}
                                </Panel>
                            </div>
                        </>)
            }
        </div>
    );
}

export default Questionario